import JSConfetti from 'js-confetti';

let canvas = document.querySelector('canvas');

if (!canvas) {
  canvas = document.createElement('canvas');
}

canvas.setAttribute('aria-hidden', 'true');
canvas.setAttribute('tabindex', '-1');

canvas.style.position = 'fixed';
canvas.style.width = '100%';
canvas.style.height = '100%';
canvas.style.top = '0px';
canvas.style.left = '0px';
canvas.style.bottom = '0px';
canvas.style.right = '0px';
canvas.style.zIndex = '1000';
canvas.style.pointerEvents = 'none';

const body = document.querySelector('body');

body?.appendChild(canvas);

export const jsConfetti = new JSConfetti({
  canvas,
});
